// import api from '@/api'

const miniMapWidgetModel = {
    state: {
        data: null,
    },
    reducers: {
        setData(state, payload) {
            return { ...state, data: payload };
        },
    },
    // eslint-disable-next-line no-unused-vars
    effects: dispatch => ({}),
};

export default miniMapWidgetModel;
